import { css } from '@emotion/react';
import fonts from 'Themes/fonts';
import colors from 'Themes/colors';

export const puritySelectorBtn = css({
    '@media(min-width: 300px)': {
        width: 60,
    },
    '@media(min-width: 768px)': {
        width: 70,
    },
    '@media(min-width: 1200px)': {

    },
});

export const puritySelector = css({
    '@media(min-width: 300px)': {
        width: '100%',
        height: 'auto',
    },
    '@media(min-width: 768px)': {
        width: 70,
        height: 70,
    },
    // '@media(min-width: 1200px)': {
    //     width: 70,
    //     height: 70,
    // },
});

export const pageHeader = css({
    '@media(min-width:300px)': {
        position: 'relative',

        '& img': {
            width: '100%',
            height: 90,
            objectFit: 'cover',
        },
        '& div': {
            position: 'absolute',
            top: '35%',
            left: '10%',
            '& p': {
                color: 'white',
                fontSize: '3rem',
                fontWeight: 700,
                letterSpacing: 2,
                transform: 'scale(1, 0.9)',
            },
        },
    },

    '@media(min-width:1200px)': {
        position: 'relative',

        '& img': {
            width: '100%',
            height: 'auto',
            objectFit: 'cover',
        },

        '& div': {
            position: 'absolute',
            top: '35%',
            left: '10%',
            '& p': {
                color: 'white',
                fontSize: '5rem',
                fontWeight: 700,
                letterSpacing: 2,
                transform: 'scale(1, 0.9)',
            },
        },
    },
});

export const purityItem = css({
    width: '100%',
    '@media(min-width:300px)': {
        justifyContent: 'space-around',
    },
    '@media(min-width:768px)': {
        gap: 40,
    },

    '@media(min-width:1200px)': {
        gap: 20,
    },

    '& .selected': {
        gap: 30,
        border: '2px solid #064E72',
    },
});

export const sizeItem = css({
    '@media(min-width:300px)': {
        '& div': {
            border: '1px solid #E6DFD8',
            borderRadius: 4,
            width: 50,
            height: 40,
            cursor: 'pointer',
        },
        '& .selected': {
            border: '1px solid #064E72',
        },
    },
    '@media(min-width:768px)': {
        '& div': {
            border: '1px solid #E6DFD8',
            borderRadius: 4,
            width: 100,
            height: 40,
            cursor: 'pointer',
        },
        '& .selected': {
            border: '1px solid #064E72',
        },
    },

});

export const paginationContainer = css({
    '@media(min-width:300px)': {
        width: 'auto',
        padding: 0,
        display: 'flex',
        justifyContent: 'center',

        '& .pagination': {
            display: 'flex',
            justifyContent: 'center',
            gap: 5,
        },
    },
    '@media(min-width:1200px)': {
        justifyContent: 'flex-end',

        '& .pagination': {
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 10,
        },
    },
});

export const filterContainer = css({
    '@media(min-width:300px)': {
        display: 'flex',
        flexDirection: 'column',
        paddingTop: 50,
        paddingBottom: 50,
        // paddingLeft: '20px',
        // paddingRight: '20px',
        gap: 20,

        '& .itemContainer': {
            gap: 0,

            '& p': {
                fontSize: '1.5rem',
                fontWeight: 700,
            },
            '& div': {
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'start',
                paddingTop: 5,
                '& div': {
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                },
                '& p': {
                    fontFamily: 'AcuminRPro',
                    fontSize: '1.4rem',
                    fontWeight: 400,
                    margin: 0,
                },
            },
        },

        '& .rangeContainer': {
            display: 'flex',
            flexWrap: 'nowrap',
            flexDirection: 'column',
            rowGap: 0,

            '& p': {
                fontSize: '1.5rem',
                fontWeight: 700,
            },
            '& div': {
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: 10,
            },
        },
    },
    '@media(min-width:1200px)': {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        width: '100%',
        gap: 30,

        '& .itemContainer': {
            display: 'flex',
            flexDirection: 'column',
            width: '35rem',
        },

        '& .rangeContainer': {
            display: 'flex',
            flexWrap: 'nowrap',
            flexDirection: 'column',
            width: '35rem',
            rowGap: 0,
        },
    },
});

export const listingContainer = css({
    '@media(min-width:300px)': {
        width: '100%',
        // padding: 0,
        paddingBottom: '40px',
    },

    '@media(min-width:1200px)': {
        padding: '0 80px',
        paddingBottom: '140px',
    },

    '@media(min-width:1400px)': {
        padding: '0 120px',
        paddingBottom: '140px',
    },
});

export const productListingTitle = css({
    font: '40px FRL-Bold, serif',
    color: colors.black,
    textAlign: 'center',
    textTransform: 'capitalize',

    '@media(min-width:768px)': {
        fontSize: '50px',
    },

    '@media(min-width:1200px)': {
        fontSize: '60px',
    },
});

export const productListingOptionsContainer = css({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    position: 'absolute',
    maxWidth: '88%',
    zIndex: 1000,
});

export const productListingOptionsText = css({
    font: '18px Archivo-Regular, sans-serif',
    display: 'inline-block',
});

export const productListingOptionsIcon = css({
    width: '27px',
});

export const sortDropdownToggle = css({
    color: `${colors.black} !important`,
    backgroundColor: `${colors.white} !important`,
    border: '0px',
    padding: '0px',
    boxShadow: 'unset !important',
    '&:hover,&:focus': {
        color: `${colors.black} !important`,
        backgroundColor: `${colors.white} !important`,
        border: '0px',
        boxShadow: 'unset !important',
    },
});

export const productsContainer = css({
    '@media(min-width:300px)': {
        // width: '100%',
        padding: '50px 0px',
    },

    '@media(min-width:1200px)': {
        padding: '50px 60px 60px 60px',
    },

    '@media(min-width:1400px)': {
        padding: '50px 100px 60px',
    },
});

export const productContainer = css({
    textAlign: 'center',
    margin: '30px 0px',
    borderWidth: 0,
});

export const productPrice = css({
    fontFamily: fonts.primaryBold,
    fontSize: 15,
    color: colors.primary,
    marginTop: '1.2em',

    '@media(min-width: 500px)': {
        fontSize: 18,
    },
});

export const productName = css({
    font: '16px Archivo-Regular, sans-serif',
    color: colors.black,
    marginTop: '1.2em',
});

export const productImg = css({
    width: '100%',
    height: 150,
    objectFit: 'contain',

    '@media(min-width:720px)': {
        height: 200,
    },
});

export const productRating = css({
    display: 'block !important',
    marginTop: '0.6em',
});

export const addToCartButton = css({
    font: '12px Archivo-Regular, sans-serif',
    color: colors.black,
    backgroundColor: colors.white,
    border: '2px solid black',
    borderRadius: '0px',
    padding: '6px 22px',
    marginTop: '1.2rem',
    transition: 'ease 0.2s',
    '&:hover,&:focus': {
        border: '2px solid black',
        backgroundColor: colors.black,
        fill: colors.white,
    },
});

export const customPaginationText = css({
    '@media(min-width: 300px)': {
        font: '16px Archivo-Regular, sans-serif',
        color: colors.black,
        '& div': {
            '& p': {
                color: 'black',
                margin: 0,
                marginTop: 2,
                fontSize: '1.4rem',
            },
            '& img': {
                width: 19,
                height: 19,
            },
        },
        '&:hover': {
            color: colors.primary,
            backgroundColor: 'unset',
        },
    },

    '@media(min-width: 1200px)': {
        font: '16px Archivo-Regular, sans-serif',
        color: colors.black,
        '& div': {
            '& p': {
                color: 'black',
                margin: 0,
                fontSize: '1rem',
            },
            '& img': {
                width: 18,
                height: 18,
            },
        },
        '&:hover': {
            color: colors.primary,
            backgroundColor: 'unset',
        },
    },

});

export const filterDropdownMenu = css({
    // mimicing reactstrap dropdown style because the filter dropdown menu is custom made
    padding: '20px',
    backgroundColor: '#FFF',
    border: '1px solid rgba(0,0,0,0.15)',
    borderRadius: '0.25rem',
    // minWidth: '400px',
});
